// ============================================================
//  EDIT THIS FILE — everything on the site lives here.
//  Videos: drop MP4s into /public/videos/ and point videoSrc
//  at them, or paste a YouTube link's ID into youtubeId.
//  Documents: drop PDFs/images into /public/docs/ and set href.
// ============================================================

export const CONTENT = {
    name: "LOGAN POMPA",
    nameLines: ["LOGAN", "POMPA"],
    role: "Cinematographer & Filmmaker",
    location: "Peoria, Arizona",
    email: "loganpompa@gmail.com",
    phone: "623-377-3710",

    hero: {
        tagline: "Horror, thriller and sci-fi — stories that put you on the edge of your seat.",
        reelId: "U0TtSOqb2Vo", // Logan's real showreel
        poster: "/images/reel-cover.webp", // Logan's reel cover frame
    },

    marquee: "Cinematographer — Horror / Thriller / Sci-Fi — ASU Film — ",

    bio: [
        "Logan Pompa is a 21-year-old filmmaker, born and raised in Peoria, Arizona, currently attending Arizona State University for a BFA in Film and Media Production. He has a deep love for horror, thriller and sci-fi, and he puts those influences into every story he puts on screen.",
        "That love for film started early — growing up watching movies and making YouTube videos as a kid. Now in his senior year and beginning his capstone, Logan wants to amaze and immerse everyone with his cinematography.",
        "Some of his favorite films — Tron: Legacy, The Thing, Jurassic Park and Star Wars — inspire the true art he finds in the vast and beautiful worlds that sci-fi creates. He wants to capture worlds like those within his frame.",
    ],

    facts: [
        { label: "Education", value: "ASU — BFA Film & Media" },
        { label: "Genres", value: "Horror / Thriller / Sci-Fi" },
        { label: "Signature", value: "Low light / Handheld / WS" },
    ],

    statement:
        "Film is never something achieved alone — it's built with the people you do it with, and bringing stories alive together is the reason I'm a filmmaker. I lean into darker tones with little to no light, because that is where suspense lives. I use wide shots to establish the surroundings — something could always be in the background — and handheld to put you in the character's shoes: the turn of a corner, the creature that jumps out, the figure in the distance, the person following behind. When people watch my films, I want them in the moment, on the edge of their seat, with a good scare. That's my goal — and that's what I want to show within my art.",

    resume: {
        education: [
            {
                school: "Arizona State University",
                degree: "BFA — Film & Media Production",
                detail: "Senior, Class of 2026 — Peoria, Arizona",
            },
        ],
        experience: [
            { role: "Writer / Director / DP / Editor", project: "Wakes the Deep — Sci-Fi Horror Short" },
            { role: "Director / DP / Editor / Sound", project: "Late Night — Horror Short" },
            { role: "Director of Photography", project: "Cien Años — Music Video" },
            // Add crew roles, PA work, student sets here
        ],
        skills: [
            "Cinematography",
            "Low-Light Lighting",
            "Handheld & Gimbal Operation",
            "Wide-Shot Composition",
            "Directing",
            "Writing",
            "Editing",
            "Sound",
            "Horror / Thriller / Sci-Fi Storytelling",
        ],
        achievements: [
            { title: "Senior Capstone", detail: "Currently in production — ASU" },
            { title: "Festival selections & awards", detail: "Add yours here as they come in" },
        ],
    },

    // Wakes the Deep production documents — the paper trail behind the film
    docs: [
        { category: "Script", title: "Wakes the Deep — Screenplay", href: "/docs/wakes-the-deep.pdf" },
        { category: "Beat Sheet", title: "Wakes the Deep — Beat Sheet", href: "/docs/wakes-the-deep-beat-sheet.docx" },
        { category: "Shot List", title: "Wakes the Deep — Shot List", href: "/docs/wakes-the-deep-shotlist.xlsx" },
    ],

    socials: [
        { label: "Instagram", href: "https://instagram.com/loganpompa" },
        { label: "YouTube", href: "https://youtube.com/@loganpompa4240" },
    ],

    projects: [
        {
            slug: "wakes-the-deep",
            title: "Wakes the Deep",
            category: "Sci-Fi Horror Short",
            year: "",
            still: "https://i.ytimg.com/vi/TAAPmtGSE6Y/hqdefault.jpg",
            youtubeId: "TAAPmtGSE6Y",
            span: "md:col-span-7",
            ratio: "aspect-video",
            description:
                "In a remote underwater lab, a marine biologist must survive as his infected partner mutates into a coral-like organism — while realizing the cure meant to save an overpopulated world may be humanity's doom.",
            credits: [
                { role: "Writer / Director / DP / Editor", name: "Logan Pompa" },
                { role: "Producers", name: "Logan Pompa, Cole Sommers" },
                { role: "1st AD / 1st AC", name: "Cole Sommers" },
                { role: "Sound", name: "Maha Alghuraydh, Naomi Jackson" },
                { role: "Grip", name: "Maha Alghuraydh, Naomi Jackson, Cole Sommers, Jeremy Egharevba" },
                { role: "Gaffer", name: "Maha Alghuraydh, Naomi Jackson, Cole Sommers, Jeremy Egharevba, Logan Pompa" },
                { role: "Cast", name: "Cole Sommers as Dr. Angler — Noah Litwin as Dr. Marlin" },
            ],
            awards: [], // e.g. { name: "Official Selection", event: "Phoenix Film Festival", year: "2026" }
        },
        {
            slug: "late-night",
            title: "Late Night",
            category: "Horror Short",
            year: "",
            still: "https://i.ytimg.com/vi/WDT_Qza8xpI/hqdefault.jpg",
            youtubeId: "WDT_Qza8xpI",
            span: "md:col-span-5",
            ratio: "aspect-[4/5]",
            description: "Dad has caught you up playing video games past your bedtime. You better hide...",
            credits: [
                { role: "Director / DP / Producer / Editor / Sound", name: "Logan Pompa" },
                { role: "Cast", name: "Dominic Staples as The Father — Andrew Dworshak as The Kid" },
            ],
            awards: [],
        },
        {
            slug: "cien-anos",
            title: "Cien Años",
            category: "Music Video",
            year: "",
            still: "https://i.ytimg.com/vi/CizkXiDMceA/hqdefault.jpg",
            youtubeId: "CizkXiDMceA",
            span: "md:col-span-5",
            ratio: "aspect-[4/5]",
            description: "A music video brought to you by Group 2 of FMP 280.",
            credits: [
                { role: "Director", name: "Danna Osorio" },
                { role: "Director of Photography", name: "Logan Pompa" },
            ],
            awards: [],
        },
        {
            slug: "car-reel",
            title: "Cars and Christ Reel",
            category: "Automotive Reel",
            year: "",
            still: "https://i.ytimg.com/vi/tSyI-p5-tlo/hqdefault.jpg",
            youtubeId: "tSyI-p5-tlo",
            span: "md:col-span-7",
            ratio: "aspect-video",
            description: "Something cool is cooking up.",
            credits: [{ role: "Director / DP / Editor / Sound", name: "Logan Pompa" }],
            awards: [],
        },
    ],

    portrait: "/images/logan-portrait.webp",
};
